// Generated by PlayNice Control Center Hero Controlled Apply.
// Source: approved Supabase Hero draft + verified Hero baseline.
// Do not edit manually unless deliberately taking Hero management out of Control Center.

export const BASE_HERO_SLIDES = [
  {
    "id": 5,
    "kind": "imageOnly",
    "image": "/hero/slide-5.jpg",
    "desktopImage": "/hero/slide-5.jpg",
    "mobileImage": "/hero/mobile/slide-5-mobile.jpg",
    "alt": "A NEW NAME IN MONTENEGRO.  BUJAIRAMI HAS ARRIVED.",
    "actionPrimary": "collection",
    "actionCollection": [
      "bujairami-too-damn-good",
      "bujairami-hectic"
    ],
    "collectionTitle": "Discover Bujairami. Discover something different."
  },
  {
    "id": 12,
    "kind": "imageOnly",
    "image": "/hero/slide-12.jpg",
    "desktopImage": "/hero/slide-12.jpg",
    "mobileImage": "/hero/mobile/slide-12-mobile.jpg",
    "alt": "YOU DON’T HAVE TO SAY A WORD. HUNDRED SILENT WAYS.",
    "actionPrimary": "product",
    "actionProductSlug": "nishane-hundred-silent-ways-x",
    "preferredSize": "5ml"
  },
  {
    "id": 9,
    "kind": "imageOnly",
    "image": "/hero/slide-9.jpg",
    "desktopImage": "/hero/slide-9.jpg",
    "mobileImage": "/hero/mobile/slide-9-mobile.jpg",
    "alt": "PlayNice limited stock fragrance campaign hero banner",
    "actionPrimary": "product",
    "actionProductSlug": "armani-i-will",
    "preferredSize": "5ml"
  },
  {
    "id": 6,
    "kind": "imageOnly",
    "image": "/hero/slide-6.jpg",
    "desktopImage": "/hero/slide-6.jpg",
    "mobileImage": "/hero/mobile/slide-6-mobile.jpg",
    "alt": "MY GEISHA UNSEEN — miris koji se ne zaboravlja. Sada u PlayNice dekantima.",
    "actionPrimary": "product",
    "actionProductSlug": "my-geisha-unseen-extrait-de-parfum",
    "preferredSize": "10ml"
  },
  {
    "id": 2,
    "kind": "imageOnly",
    "image": "/hero/slide-2.jpg",
    "desktopImage": "/hero/slide-2.jpg",
    "mobileImage": "/hero/mobile/slide-2-mobile.jpg",
    "alt": "PlayNice – luxury fragrance experience and trust",
    "actionPrimary": "manifesto",
    "manifestoType": "confidence"
  },
  {
    "id": 3,
    "kind": "imageOnly",
    "image": "/hero/slide-3.jpg",
    "desktopImage": "/hero/slide-3.jpg",
    "mobileImage": "/hero/mobile/slide-3-mobile.jpg",
    "alt": "SUCCESS DOESN’T HAVE A SEASON.",
    "actionPrimary": "product",
    "actionProductSlug": "creed-aventus-cologne",
    "preferredSize": "5ml"
  },
  {
    "id": 4,
    "kind": "imageOnly",
    "image": "/hero/slide-4.jpg",
    "desktopImage": "/hero/slide-4.jpg",
    "mobileImage": "/hero/mobile/slide-4-mobile.jpg",
    "alt": "PlayNice Premium Fragrance House – gentleman with fragrance",
    "actionPrimary": "manifesto",
    "manifestoType": "playnice-mission"
  },
  {
    "id": 1,
    "kind": "imageOnly",
    "image": "/hero/slide-1-fix.jpg",
    "desktopImage": "/hero/slide-1-fix.jpg",
    "mobileImage": "/hero/mobile/slide-1-mobile.jpg",
    "alt": "Thomas Kosmala No. 4 Après l'Amour Eau de Parfum – magnetic, modern fragrance at PlayNice.",
    "actionPrimary": "product",
    "actionProductSlug": "thomas-kosmala-no-4-apres-lamour",
    "preferredSize": "10ml"
  },
  {
    "id": 7,
    "kind": "imageOnly",
    "image": "/hero/slide-7.jpg",
    "desktopImage": "/hero/slide-7.jpg",
    "mobileImage": "/hero/mobile/slide-7-mobile.jpg",
    "alt": "Optional: special action, drop ili limited stock",
    "actionPrimary": "product",
    "actionProductSlug": "armaf-club-de-nuit-intense-overdose",
    "preferredSize": "10ml"
  },
  {
    "id": 8,
    "kind": "imageOnly",
    "image": "/hero/slide-8.jpg",
    "desktopImage": "/hero/slide-8.jpg",
    "mobileImage": "/hero/mobile/slide-8-mobile.jpg",
    "alt": "PlayNice premium packaging with fragrance gifts and branded accessories",
    "actionPrimary": "manifesto",
    "manifestoType": "details"
  },
  {
    "id": 10,
    "kind": "imageOnly",
    "image": "/hero/slide-10.jpg",
    "desktopImage": "/hero/slide-10.jpg",
    "mobileImage": "/hero/mobile/slide-10-mobile.jpg",
    "alt": "Odobreno za večernji sastanak. Šta se dešava posle deserta, ostaje između vas dvoje.",
    "actionPrimary": "product",
    "actionProductSlug": "tom-ford-noir-extreme",
    "preferredSize": "5ml"
  },
  {
    "id": 11,
    "kind": "imageOnly",
    "image": "/hero/slide-11.jpg",
    "desktopImage": "/hero/slide-11.jpg",
    "mobileImage": "/hero/mobile/slide-11-mobile.jpg",
    "alt": "NE TREBA SVE DA BUDE NEŽNO. OMBRÉ LEATHER PARFUM.",
    "actionPrimary": "product",
    "actionProductSlug": "tom-ford-ombre-leather-parfum",
    "preferredSize": "5ml"
  }
];
